import { FileCard } from "src/base-components/FileCard";
import type { FileContentBlock } from "src/clients/agent-management";

type Props = {
  fileBlocks: FileContentBlock[];
};

/**
 * Attachments echoed back on a user message's content blocks. Copilot
 * attachments always live in the workspace's live Files API environment.
 * Preview-only: opening the viewer is enough on a sent message.
 */
export const UserMessageAttachments: React.FC<Props> = ({ fileBlocks }) => (
  // Capped to the same width as ChatUserBubble so the cards read as part of
  // the user's (right-aligned) message rather than spanning the full thread.
  <ul
    className="mt-1 flex w-full max-w-[75%] flex-col gap-1"
    data-loc="unified-copilot-message-attachments"
  >
    {fileBlocks.map((block, index) => (
      <li key={`${block.file_id}-${index}`}>
        <FileCard
          dataLoc="unified-copilot-message-attachment"
          fileEnv="live"
          fileId={block.file_id}
          showDownload={false}
        />
      </li>
    ))}
  </ul>
);
